<template>
    <table-simple-value :value="value">
        <slot name="prepend"></slot>
        <user-view v-if="value.user != undefined" :user="value.user" :message="value.message" :payload="value.payload" />
        <user-view v-else-if="value.company != undefined" :company="value.company" :message="value.message"
            :payload="value.payload" />
        <user-view v-else-if="value.group != undefined" :group="value.group" :message="value.message" :payload="value.payload" />
        <user-view v-else :user="value.value" :message="value.message" :payload="value.payload" />
    </table-simple-value>
</template>

<script>
import TableSimpleValue from './TableSimpleValue.vue';
import UserView from './UserView.vue';

export default {
    name: 'TableUserValue',
    components: { TableSimpleValue, UserView },
    props: {
        value: {
            type: Object,
            default() {
                return {
                    actions: null,
                    value: {},
                };
            },
        },
    },
};
</script>

<style scoped>

</style>
